const hotels = {
  accommodation: "住宿", // translated
  hotel: "酒店", // translated
  hotels: "酒店", // translated
  back: "返回", // translated
  rooms: "客房", // translated
  viewPictures: "查看图片", // translated
  showMore: "展示更多", // translated
  bookingInformation: "预订信息", // translated
  importantInformation: "重要信息", // translated
  cancellationPolicy: "取消政策", // translated
  from: "从", // translated
  to: "到", // translated
  cancellationIs: "取消是", // translated
  free: "自由的", // translated
  chargeableWithFeeOf: "需缴纳费用", // translated
  prebook: "预售书", // translated
  guests: "客人", // translated
  payment: "支付", // translated
  byClicking: "通过点击", // translated
  next: "下一个", // translated
  youAreAgreeingToOur: "您同意我们的", // translated
  termsAndConditions: "条款和条件", // translated
  previous: "以前的", // translated
  cancel: "取消", // translated
  mealPlan: "用餐计划", // translated
  roomType: "房型", // translated
  description: "描述", // translated
  readLess: "少读", // translated
  readMore: "阅读更多", // translated
  facilities: "设施", // translated
  viewLess: "查看更少", // translated
  viewMore: "查看更多", // translated
  less: "较少的", // translated
  more: "更多的", // translated
  notAvailable_short: "不适用", // translated
  backToHotelList: "返回酒店列表", // translated
  viewOnMap: "在地图上查看", // translated
  sleeps: "睡觉", // translated
  adults: "成年人", // translated
  yearsOld: "岁", // translated
  type: "类型", // translated
  bedding: "寝具", // translated
  selectRoom: "选择房间", // translated
  selectRooms: "选择客房", // translated
  city: "城市", // translated
  checkIn: "报到", // translated
  checkOut: "查看", // translated
  date: "日期", // translated
  dates: "日期", // translated
  persons: "人员", // translated
  stillOnTrialQuestionToUpgrade:
    "哎呀！您似乎仍在试用会员资格。您需要成为已确认的会员才能进行预订。您想现在升级吗？", // translated
  stillOnTrialQuestionToUpgradeNonElligib:
    "哎呀！您似乎尚未订阅。您需要成为已确认的会员才能进行预订。您想现在升级吗？", // translated
  completeProfile: "请先填写您的用户资料", // translated
  upgrade: "升级", // translated
  close: "关闭", // translated
  viewDetails: "查看详情", // translated
  name: "姓名", // translated
  rating: "评分", // translated
  budget: "预算", // translated
  orderBy: "排序", // translated
  priceLowestFirst: "价格（最低的优先）", // translated
  priceHighestFirst: "价格（最高的在前）", // translated
  ratingLowestFirst: "评级（最低的优先）", // translated
  ratingHighestFirst: "评分（最高的在前）", // translated
  starRatingAndPrice: "星级及价格", // translated
  biggestSavingsFirst: "最大的节省优先", // translated
  select: "选择", // translated
  reset: "重置", // translated
  apply: "确定", // translated
  filterBy: "过滤", // translated
  myProfile: "我的账户", // translated
  login: "登录", // translated
  roomOnly: "仅限房间", // translated
  bedAndBreakfast: "床和早餐", // translated
  halfBoard: "半食宿", // translated
  fullBoard: "全膳", // translated
  allInclusive: "全包", // translated
  filter: "筛选", // translated
  mapView: "地图视图", // translated
  results: "结果", // translated
  listView: "列表显示", // translated
  newSearch: "新搜索", // translated
  editSearch: "编辑搜索", // translated
  all: "全部", // translated
  multiple: "多种的", // translated
  editProfile: "编辑个人资料", // translated
  backToHotelsList: "返回酒店列表", // translated
  roomName: "房间名称", // translated
  mealType: "膳食类型", // translated
  freeCancellation: "免费取消", // translated
  yes: "是的", // translated
  no: "不", // translated
  filters: "过滤器", // translated
  cancellationNonRefundable: "取消不可退款", // translated
  hotelRating: "酒店评级", // translated
  any: "任何", // translated
  off: "关闭", // translated
  performNewSearch: "执行新的搜索", // translated
};

export default hotels;
